import { Minuta, Processo } from '../../modelo';
import { IProcessoDto } from '../../api/dto/ProcessoDto';

export class MapeadorProcesso {

    public toProcesso(processoDto: Partial<Processo>): Processo {
        return Processo.novo(processoDto as Partial<Processo>);
    }

    public toProcessos(processosDto: IProcessoDto[] | Partial<Processo>[]): Processo[] {
        return processosDto.reduce((resultado, processoDto) => {
            // const processo = resultado.find(proc => proc.identificadorProcesso === processoDto.identificadorProcesso);
            if (processoDto) {
                resultado.push(this.toProcesso(processoDto as Partial<Processo>));
            }
            return resultado;
        }, [] as Processo[]);
    }
}

export default new MapeadorProcesso();
